import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import moment from "moment";

const Row = ({ row }) => {
  return (
    <TableRow
      sx={{
        "&:nth-of-type(odd)": {
          backgroundColor: "background.custom",
        },
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell component="th" scope="row" align="left" color="primary.main">
        {row?.product?.itemName || "null"}
      </TableCell>
      <TableCell component="th" scope="row" align="left">
        {moment(row?.expiryDate).format("MMMM Do YYYY")}
      </TableCell>
    </TableRow>
  );
};
export default function InventoryOverviewExpiringTable({ data }) {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 350 }} aria-label="inventory-overview-table">
          <TableBody>
            {data?.length
              ? data.map((row, i) => <Row key={row._id} row={row} />)
              : null}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
